import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Modal, { ModalProps } from 'components/Modal/Modal';
import Markdown from 'components/Markdown/Markdown';
import { useSelector } from 'store';

import './AuctionDocumentsModal.scss';

const AuctionDocumentsModalContent: FC<ModalProps> = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslation();
  const rfpTerms = useSelector((store) => store.rfp.data.rfp_terms);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      variant="kliparo"
      className="enkrateia-auction-documents-modal"
      title={t('pages.prosforaProject.documentsModal.title')}
    >
      <div className="header-text">
        <Markdown>{t('pages.prosforaProject.documentsModal.subtitle__markdownEnabled')}</Markdown>
      </div>
      <div className="terms">
        <Markdown>{rfpTerms}</Markdown>
      </div>
      <div className="footer-text">
        <Markdown>{t('pages.prosforaProject.documentsModal.bottomText__markdownEnabled')}</Markdown>
      </div>
    </Modal>
  );
};

const AuctionDocumentsModal: FC<ModalProps> = ({ isOpen, onRequestClose }) => {
  if (!isOpen) {
    return null;
  }

  return <AuctionDocumentsModalContent isOpen={isOpen} onRequestClose={onRequestClose} />;
};

export default AuctionDocumentsModal;
